/* import __COLOCATED_TEMPLATE__ from './footer.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import Component from '@glimmer/component';

export default class Footer extends Component {
  get onboardingFooterWormholeElement() {
    return document.getElementById('onboarding-footer-wormhole');
  }
}
